import angular from 'angular';
import constants from 'app/constants';
import {
  ecatDataService,
  ecatSharedModelService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';

import controller from './cri-statement.controller';
import directive from './cri-statement.directive';
import statementDocument from '../statementDocument';
import ecatCRIStatementNotesMessagesTpl from './messages/ecat-cri-notes.messages.html';
import attachStatementDialog from '../attachStatementDialog';

export default angular.module('app.components.advisory.ecat.criStatement', [
  alerts,
  ecatDataService,
  ecatSharedModelService,
  confirmDialog,
  constants,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
  statementDocument,
  attachStatementDialog
])
  .directive('ecatCriStatement', directive)
  .controller('CRIStatementController', controller)
  .run(($templateCache) => {
    $templateCache.put('ecat.cri.notes.messages.html', ecatCRIStatementNotesMessagesTpl);
  })
  .name;
  
console.log('app.components.advisory.ecat.criStatement created');
